import api from '@pray/shared/utils/api';
import { ObjectResponse } from '@pray/shared/utils/api/types/response';

import { CreditBalanceResponse, UpdateAllowOveragesRequest } from './types';

type UpdateAllowOveragesProps = {
  artistId: string;
  allowOverage: boolean;
};

export const updateAllowOverages = async ({ artistId, allowOverage }: UpdateAllowOveragesProps) => {
  if (!artistId) throw Error('Artist ID is required');

  const url = `web/studio/artists/${artistId}/credits/account`;

  const payload: UpdateAllowOveragesRequest = {
    allow_overages: allowOverage,
  };

  const response = await api.executePatchRequest<ObjectResponse<CreditBalanceResponse>>(url, payload);

  return response.data;
};
